import { createIcon } from '../utils';

export const ShockIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.8331 1.66663L3.41094 10.5732C3.12026 10.922 2.97492 11.0964 2.9727 11.2437C2.97077 11.3717 3.02783 11.4935 3.12744 11.574C3.24201 11.6666 3.46904 11.6666 3.92308 11.6666H9.99972L9.16639 18.3333L16.5885 9.42675C16.8792 9.07794 17.0245 8.90354 17.0267 8.75624C17.0287 8.62819 16.9716 8.50637 16.872 8.42588C16.7574 8.33329 16.5304 8.33329 16.0764 8.33329H9.99972L10.8331 1.66663Z"
        fill="#EF4444"
        stroke="#EF4444"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'ShockIcon',
  },
);
